/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from '@apollo/client'
import React from 'react'
import PropTypes from 'prop-types'
import { useEvolvedContext } from '../../context'
import ProductsList, { IProduct } from '../products-list'
import query from './query.graphql'

// eg;
// "2001/1ed4b513-8ce0-4ae4-8356-3033bdadc383"
// "/2001/1ed4b513-8ce0-4ae4-8356-3033bdadc383"
// "/2001/1ed4b513-8ce0-4ae4-8356-3033bdadc383?"
// "/2001/1ed4b513-8ce0-4ae4-8356-3033bdadc383?foo=bar"
const urlProductIdRegex = /^\/?(\d+)\/([-0-9a-zA-Z]+)\/?(\?.*)?$/

const parseUrlProductId = (str: string): { id: string; shop: number } => {
  // prettier-ignore
  const [
    // Skip the full string match
    ,
    shop,
    id,
  ] = urlProductIdRegex.exec(str) || []

  return { id, shop: Number(shop) }
}

const convertProduct = (product: any): IProduct => {
  const [variant, ...otherVariants] = product.variants.map((variant: any) => ({
    price: {
      originalPrice: variant.originalPrice,
      discountedPrice: variant.discountPrice,
      effectivePrice: variant.discountPrice ?? variant.originalPrice,
    },
  }))
  const firstVariant = product.variants[0]

  return {
    brand: firstVariant.brand,
    variantGroupCode: firstVariant.variantGroupCode,
    otherVariants,
    variant,
    shop: product.shop,
    image: firstVariant.images?.[0]?.url,
    name: product.title,
  }
}

export const ProductsInMarkdown = ({ ids = '' }: { ids?: string }) => {
  const isEvolved = useEvolvedContext()
  const { loading, error, data } = useQuery(query, {
    errorPolicy: 'ignore',
    context: { version: 2 },
    variables: {
      ids: ids
        .split(',')
        .map(parseUrlProductId)
        .filter(({ id, shop }) => id && shop),
    },
    skip: !isEvolved,
  })

  if (!isEvolved) {
    return null
  }

  if (loading) {
    // TODO: Loading spinner / skeleton?
    return null
  }

  if (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    return null
  }

  const { products = [] } = data || {}
  const convertedProducts = products.reduce((acc: any[], product: any) => {
    const hasVariants = product && product.variants.length > 0
    if (!hasVariants) {
      return acc
    }

    // In a try-catch because we don't have proper types here and there are a
    // number of potentially risky assumptions when converting the product
    try {
      acc.push(convertProduct(product))
    } catch (e) {
      console.error(e)
    }

    return acc
  }, [])

  return (
    <ProductsList
      products={convertedProducts}
      page={0}
      itemsPerPage={8}
      basePath=""
    />
  )
}

ProductsInMarkdown.propTypes = {
  ids: PropTypes.string,
}
